export default {
    Russia: '113',
    RootArea: '0',
};
